/* eslint-disable @typescript-eslint/default-param-last */
import { Reducer } from 'redux';
import { IEmployee } from '../../../types';
import { Employee } from '../../Employee';
import { IEmployeesState } from '../../types';
import { Employees } from './types';

const initialState: IEmployeesState | null = null;

export const employeesReducer: Reducer<IEmployeesState | null> = (state = initialState, action) => {
  switch (action.type) {
    case Employees.GET_EMPLOYEES_SUCCESS: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case Employees.GET_ACTION_REQUIRED_EMPLOYEES_COUNT_REQUEST: {
      return {
        ...state,
        requiresReviewTotal: 0,
      };
    }
    case Employees.GET_ACTION_REQUIRED_EMPLOYEES_COUNT_SUCCESS: {
      return {
        ...state,
        requiresReviewTotal: action.payload.total,
      };
    }
    case Employee.UPDATE_EMPLOYEE_SITE_ROLE_SUCCESS: {
      const employeeResponse = action.payload as IEmployee;

      return {
        ...state,
        ...(state?.data && { data: state.data.map((emp) => (emp.id === employeeResponse.id ? employeeResponse : emp)) }),
      };
    }
    case Employee.UPDATE_EMPLOYEE_SUCCESS: {
      const { isReviewingEmployee } = action.meta;
      return {
        ...state,
        ...(isReviewingEmployee && state?.requiresReviewTotal && { requiresReviewTotal: state.requiresReviewTotal - 1 }),
      };
    }
    default: {
      return state;
    }
  }
};
